import { connect } from 'react-redux';
import DemoTourMap from '../../../features/demoMode/reading/DemoModeTour/DemoTourMap';
import { selectors } from '../../../root/reading/root';

const mapStateToProps = state => {
    return {
        activeStep: selectors.getActiveStep(state),
        visitedTourSteps: selectors.getVisitedTourSteps(state),
    };
};

export default connect(mapStateToProps)(DemoTourMap);
